import React from 'react';

export default {
  MIN_UC: {
    title: 'Min UC',
    infoText: () => (
      <React.Fragment>
        <p>Här laddar ni upp kreditupplysningar från MinUC. </p>
        <p>
          För att säkerställa att rätt förutsättningar finns för att kunna byta
          sin bostad kräver hyresvärdarna en kreditupplysning på{' '}
          <strong>
            samtliga som är tänkta att stå skrivna på det nya hyreskontraktet.
          </strong>
        </p>

        <p>
          Du laddar enkelt ned en kreditupplysning via tjänsten "Min upplysning"
          på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.minuc.se/min-upplysning">
            minuc.se
          </a>{' '}
          (kostnad 29kr/ person)
        </p>

        <p>
          Observera att kreditupplysningen måste inhämtas personligen från
          MinUC. <strong>Inga andra kreditupplysningar godkänns.</strong>
        </p>

        <h3>
          <strong>Frågor och svar:</strong>
        </h3>

        <p>
          <strong>Varför måste jag ladda upp en kreditupplysning?</strong>
          <br />
          För att säkerställa att samtliga bytesparter har rätt förutsättningar
          för att kunna byta. Detta är en trygghet för dig som bytespart och
          ökar förutsättningarna för ett smidigt byte.
        </p>

        <p>
          <strong>
            Jag har redan en kreditupplysning från ett annat företag än MinUC.
            Varför godkänner ni inte den?
          </strong>
          <br />
          Allt fler hyresvärdar kräver att man bifogar en kreditupplysning från
          just MinUC i sin bytesansökan. Detta är inget som vi på Bytesansökan
          kan påverka.
        </p>

        <p>
          <strong>Varför måste jag själv hämta en kreditupplysning?</strong>
          <br />
          Många hyresvärdar kräver att denna inhämtas personligen.
        </p>

        <p>
          <strong>
            Min make / maka / sambo står på kontraktet idag men ska inte flytta
            med. Måste denne ändå ladda upp en kreditupplysning?
          </strong>
          <br />
          Nej, det gäller endast de som önskar stå på det nya hyreskontraktet.
        </p>

        <p>
          <strong>
            Hjälp! Jag har en eller flera betalningsanmärkningar. Kommer jag
            inte att kunna byta nu?
          </strong>
          <br />
          Detta är något som man måste titta på individuellt. Kontakta oss för
          vidare dialog på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </a>
          .
        </p>

        <p>
          Det går bra att ladda upp dokument som är inscannade så väl som
          fotokopior.
        </p>
        <p>Tänk på att:</p>
        <ul>
          <li>Alla fyra hörn skall vara synliga</li>
          <li>Kvaliteten skall vara god även vid utskrift</li>
          <li>
            Filerna måste vara i något av följande format, .pdf / .jpg / .png
          </li>
        </ul>

        <p>
          <strong>Tips: </strong>För att fota dokument på bästa sätt
          rekommenderar vi att du använder dig av en app som scannar av
          dokument. Exempel på appar som fungerar bra till både iOS och Android
          är Adobe Scan och Genius Scan, båda helt gratis att använda. <br />
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/adobe-scan-document-scanner/id1199564834">
                Länk till Adobe Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/genius-scan-pdf-scanner/id377672876">
                Länk till Genius Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=sv">
                Länk till Adobe Scan Android
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free&hl=sv">
                Länk till Genius Scan Android
              </a>
            </li>
          </ul>
        </p>

        <p>
          Behöver du hjälp? Hör av dig till oss på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </a>
          .
        </p>
      </React.Fragment>
    ),
  },
  ID_PROOF: {
    title: 'Familjebevis',
    infoText: () => (
      <React.Fragment>
        <p>
          Här laddar ni upp era familjebevis. Ett familjebevis är en viss typ av
          personbevis som inte bara visar folkbokföringsadress utan även
          eventuella barn och andra familjeförhållanden.
        </p>

        <p>
          Detta har på senare tid blivit allt vanligare att hyresvärdarna kräver
          och <strong>därför är detta obligatoriskt för alla.</strong> Oavsett
          om man är singel, sambo, ogift, gift eller lever under andra
          konstellationer så krävs ett familjebevis.
        </p>
        <p>
          <strong>Familjebeviset får ej vara äldre än 3 månader.</strong>
        </p>
        <p>
          Tänk på att ladda upp familjebevis på{' '}
          <strong>
            samtliga som skall bo i den nya lägenheten, även personer under 18.{' '}
          </strong>
          Enklast är att varje vuxen beställer ett där även eventuella barns
          personuppgifter framgår. På så vis slipper man beställa flera olika.
        </p>
        <p>
          <strong>
            Familjebeviset skickas till din folkbokföringsadress via post och
            går ej att hämta online.
          </strong>
        </p>
        <p>
          <strong>Körkort, ID-kort samt pass gäller ej som personbevis.</strong>
        </p>
        <p>
          Beställning av familjebevis gör du enklast{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.skatteverket.se/4.b1014b415f3321c0de1413.html#!/bestall?kod=1209">
            här
          </a>{' '}
          (länk till Skatteverket).
        </p>
        <p>
          Det går bra att ladda upp dokument som är inscannade så väl som
          fotokopior.
        </p>
        <p>Tänk på att:</p>
        <ul>
          <li>Alla fyra hörn skall vara synliga</li>
          <li>Kvaliteten skall vara god även vid utskrift</li>
          <li>
            Filerna måste vara i något av följande format, .pdf / .jpg / .png
          </li>
        </ul>

        <p>
          <strong>Tips: </strong>För att fota dokument på bästa sätt
          rekommenderar vi att du använder dig av en app som scannar av
          dokument. Exempel på appar som fungerar bra till både iOS och Android
          är Adobe Scan och Genius Scan, båda helt gratis att använda. <br />
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/adobe-scan-document-scanner/id1199564834">
                Länk till Adobe Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/genius-scan-pdf-scanner/id377672876">
                Länk till Genius Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=sv">
                Länk till Adobe Scan Android
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free&hl=sv">
                Länk till Genius Scan Android
              </a>
            </li>
          </ul>
        </p>

        <p>
          Behöver du hjälp? Hör av dig till oss på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </a>
          .
        </p>
      </React.Fragment>
    ),
  },
  INCOME_BASE: {
    title: 'Inkomstunderlag',
    infoText: () => (
      <React.Fragment>
        <p>
          Här laddar du upp underlag på din löpande inkomst. Det som krävs är
          ett av behörig underskrivet{' '}
          <strong>
            anställningsavtal samt de 3 senaste lönespecifikationerna.
          </strong>
        </p>
        <p>
          <strong>Inkomstdeklaration gäller ej som inkomstunderlag.</strong>
        </p>
        <p>
          <strong>
            Föräldraledighet / Försäkringskassa, A-kassa, CSN, pension m.m.
            gäller också som inkomst
          </strong>{' '}
          och då bifogas liknande underlag i form av utbetalningar, beslut m.m.
        </p>
        <p>
          <strong>Som egenföretagare </strong>(Enskild firma) behövs balans-
          samt resultat-rapport.
        </p>
        <p>
          Som egenföretagare (Aktiebolag) gäller samma som för Enskild firma och
          i de fall det finns en revisor bifogas med fördel även ett intyg på
          löneutbetalningar från denne. Besparingar räknas inte som löpande
          inkomst.
        </p>
        <p>
          Ibland händer det att någon av bytesparterna har ett{' '}
          <strong>betalningsföreläggande </strong>
          och i vissa fall kan detta vara okej hos hyresvärdarna och i vissa
          fall inte. Det är därför{' '}
          <strong>
            viktigt att DU som bytespart informerar oss om detta
          </strong>{' '}
          i ett så tidigt skede som möjligt i processen så att vi kan kika
          närmare på detta innan vi skickar in bytesansökan.
        </p>
        <p>
          Det går bra att skicka dokument som är inscannade så väl som
          fotokopior.
        </p>
        <p>Tänk på att:</p>
        <ul>
          <li>Alla fyra hörn skall vara synliga</li>
          <li>Kvaliteten skall vara god även vid utskrift</li>
          <li>
            Filerna måste vara i något av följande format, .pdf / .jpg / .png
          </li>
        </ul>

        <p>
          <strong>Tips: </strong>För att fota dokument på bästa sätt
          rekommenderar vi att du använder dig av en app som scannar av
          dokument. Exempel på appar som fungerar bra till både iOS och Android
          är Adobe Scan och Genius Scan, båda helt gratis att använda. <br />
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/adobe-scan-document-scanner/id1199564834">
                Länk till Adobe Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/genius-scan-pdf-scanner/id377672876">
                Länk till Genius Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=sv">
                Länk till Adobe Scan Android
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free&hl=sv">
                Länk till Genius Scan Android
              </a>
            </li>
          </ul>
        </p>

        <p>
          Behöver du hjälp? Hör av dig till oss på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </a>
          .
        </p>
      </React.Fragment>
    ),
  },
  RENTAL_AGREEMENT: {
    title: 'Hyresavtal',
    infoText: () => (
      <React.Fragment>
        <p>
          Här laddar du upp en kopia på ditt nuvarande hyresavtal (samtliga
          sidor).{' '}
          <strong>
            Hyresavtalet skall vara underskrivet av såväl hyresvärd som
            hyresgäst. Skärmavbild eller liknade från hyresvärdens hemsida
            gäller inte, endast kopia på originalkontrakt.{' '}
          </strong>
        </p>
        <p>
          Ibland händer det att hyreskontraktet försvunnit och då går det bra
          att kontakta sin hyresvärd och be denne skicka en kopia.
        </p>
        <p>
          Det går bra att skicka dokument som är inscannade så väl som
          fotokopior.
        </p>
        <p>Tänk på att:</p>
        <ul>
          <li>Alla fyra hörn skall vara synliga</li>
          <li>Kvaliteten skall vara god även vid utskrift</li>
          <li>
            Filerna måste vara i något av följande format, .pdf / .jpg / .png
          </li>
        </ul>

        <p>
          <strong>Tips: </strong>För att fota dokument på bästa sätt
          rekommenderar vi att du använder dig av en app som scannar av
          dokument. Exempel på appar som fungerar bra till både iOS och Android
          är Adobe Scan och Genius Scan, båda helt gratis att använda. <br />
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/adobe-scan-document-scanner/id1199564834">
                Länk till Adobe Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/genius-scan-pdf-scanner/id377672876">
                Länk till Genius Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=sv">
                Länk till Adobe Scan Android
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free&hl=sv">
                Länk till Genius Scan Android
              </a>
            </li>
          </ul>
        </p>

        <p>
          Behöver du hjälp? Hör av dig till oss på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </a>
          .
        </p>
      </React.Fragment>
    ),
  },
  RENTAL_BASE: {
    title: 'Aktuell hyra',
    infoText: () => (
      <React.Fragment>
        <p>
          Här laddar du upp en kopia på hyresavi alternativt en skärmavbild från
          bank på autogiro / betalning.
        </p>
        <p>
          Det går bra att skicka dokument som är inscannade så väl som
          fotokopior.
        </p>
        <p>Tänk på att:</p>
        <ul>
          <li>Alla fyra hörn skall vara synliga</li>
          <li>Kvaliteten skall vara god även vid utskrift</li>
          <li>
            Filerna måste vara i något av följande format, .pdf / .jpg / .png
          </li>
        </ul>

        <p>
          <strong>Tips: </strong>För att fota dokument på bästa sätt
          rekommenderar vi att du använder dig av en app som scannar av
          dokument. Exempel på appar som fungerar bra till både iOS och Android
          är Adobe Scan och Genius Scan, båda helt gratis att använda. <br />
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/adobe-scan-document-scanner/id1199564834">
                Länk till Adobe Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/se/app/genius-scan-pdf-scanner/id377672876">
                Länk till Genius Scan iOS
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=sv">
                Länk till Adobe Scan Android
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free&hl=sv">
                Länk till Genius Scan Android
              </a>
            </li>
          </ul>
        </p>

        <p>
          Behöver du hjälp? Hör av dig till oss på{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </a>
          .
        </p>
      </React.Fragment>
    ),
  },
};



// WEBPACK FOOTER //
// ./src/views/Upload/copy.js